export default () => ({
  handler: 'relativeUrl',
  data: ({ ftpGameId }) => (
    `/casino/ftp-games/${ftpGameId}/launch`
  ),
});
